import React from "react"
import { Button } from 'primereact/button';
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Callbacks } from "jquery";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList } from "../../entities/Constants";
import { WarningAlertComponent } from "./WarningAlertComponent";
import { SuccessAlertComponent } from "./SuccessAlertComponent";
import { InformationalAlertComponent } from "./InformationalAlertComponent";
import { InformationalRichTextComponent } from "./InformationalRichTextComponent";
import HintContentComponent from "./HintContentComponent";
import { ErrorAlertComponent } from "./ErrorAlertComponent";
import { GeneralCalloutComponent } from "./GeneralCalloutComponent";
import TimeEstimateCalloutComponent from "./TimeEstimateComponent";

interface Props {
    hintExpansionTitle: string;
    calloutType: string;
    bodyMsg: string;
    title: string;
    isEng: boolean;
    Visible: boolean;
    field: FormSectionElements;
    callbackStepIndex?: (index: number, currentIndex?: number) => void;
}

interface State {
    isExpanded: boolean;
    isVisiable: boolean;
}

export class HintExpansionComponent extends React.Component<Props, State> {
    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: this.props.field?.hintExpanded ?? false,
            isVisiable: false,
        };
    }

    componentDidMount(): void {
        this.setState({ ...this.state, isVisiable: this.props.Visible });
    }

    generateHtmlString = () => {
        let html = [];
        if (!this.state.isVisiable) return html;
        let hintTitle = this.props.hintExpansionTitle;

        // let title = this.props.title;
        const typeRegex = /<\s*(img|svg) ((.|\n)*?)(\/)?>/gi;
        const type = typeRegex.test(this.props.bodyMsg) ? 'Callout' : "Nomoral";
        // html.push(
        //     <HintContentComponent 
        //         type={type}
        //         title={hintTitle}
        //     >
        //         {this.getHintContent()}
        //     </HintContentComponent>
        // )

        html.push(
            <div className={type === 'Nomoral' ? `ontario-hint-expander__container ` : ""}>

                <button
                    className={`ontario-hint-expander__button ${this.state.isExpanded ? "ontario-expander--active" : ""}`}
                    id="hint-expander-button-id-3"
                    aria-controls="hint-expander-content-3"
                    aria-expanded={this.state.isExpanded}
                    data-toggle="ontario-collapse"
                    onClick={(e) => {
                        this.setState({ isExpanded: !this.state.isExpanded });
                    }}>

                    {!this.state.isExpanded &&
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    }

                    {this.state.isExpanded &&
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    }
                    {hintTitle}
                </button>
                {this.getHintContent()}
            </div>
        );

        // let bodyMsg=this.props.bodyMsg;
        // if(/<[a-z][\s\S]*>/i.test(this.props.bodyMsg)){
        //     bodyMsg=htmlToReactParser.parse(this.props.bodyMsg);
        // }

        // switch (this.props.calloutType) {
        //     case 'informational':
        //         html.push(
        //             this.state.isExpanded && (
        //                 <InformationalAlertComponent
        //                     isEng={this.props.isEng}
        //                     field={this.props.field}
        //                 />
        //             ));
        //         break;
        //     case 'richText':
        //         html.push(
        //             this.state.isExpanded && (
        //                 <InformationalRichTextComponent
        //                     isEng={this.props.isEng}
        //                     bodyMsg={bodyMsg}
        //                     title={this.props.title}
        //                 />
        //             ));
        //         break;
        //     case 'warning':
        //         html.push(
        //             this.state.isExpanded && (
        //                 <WarningAlertComponent
        //                     isEng={this.props.isEng}
        //                     bodyMsg={bodyMsg}
        //                     title={this.props.title}
        //                     Visible={this.props.Visible}
        //                 />
        //             ));
        //         break;
        //     case 'success':
        //         html.push(
        //             this.state.isExpanded && (
        //                 <SuccessAlertComponent
        //                     isEng={this.props.isEng}
        //                     bodyMsg={bodyMsg}
        //                     title={this.props.title}
        //                     Visible={this.props.Visible}
        //                     field={this.props.field}
        //                 />
        //             ));
        //         break;
        // }
        return html;
    }

    getHintContent = () => {
        if (!this.state.isExpanded) return <></>;

        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser();
        let bodyMsg = this.props.bodyMsg;
        if (/<[a-z][\s\S]*>/i.test(this.props.bodyMsg)) {
            bodyMsg = htmlToReactParser.parse(this.props.bodyMsg);
        }

        switch (this.props.calloutType) {
            case 'HTML':
                bodyMsg = this.props.isEng?this.props.field.callOutBoxBody: this.props.field.callOutBoxBodyFRA;
                const doc = new DOMParser().parseFromString(bodyMsg, 'text/html');
                bodyMsg = doc.body.textContent || '';
                bodyMsg = htmlToReactParser.parse(bodyMsg);
                return (
                    <GeneralCalloutComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                    />
                )
            case 'general':
                return (
                    <GeneralCalloutComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                    />
                );
            case 'timeEstimate':
                return (
                    <TimeEstimateCalloutComponent
                        field={this.props.field}>
                            {bodyMsg}
                    </TimeEstimateCalloutComponent>
                )
            case 'informational':
                return (
                    <InformationalAlertComponent
                        isEng={this.props.isEng}
                        field={this.props.field}
                    />
                );
            case 'richText':
                return (
                    <InformationalRichTextComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                        field={this.props.field}
                        callbackStepIndex={this.props.callbackStepIndex}
                    />
                );
            case 'warning':
                return (
                    <WarningAlertComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                        Visible={this.props.Visible}
                    />
                );
            case 'success':
                return (
                    <SuccessAlertComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                        Visible={this.props.Visible}
                        field={this.props.field}
                    />
                );
            case 'error':
                return (
                    <ErrorAlertComponent
                        isEng={this.props.isEng}
                        bodyMsg={bodyMsg}
                        title={this.props.title}
                        Visible={this.props.Visible}
                        field={this.props.field}
                    />
                )
            default: return <></>
        }
    }


    render() {
        // if (!this.props.Visible) return <></>;
        return (
            this.generateHtmlString()
        )
    }
}
